import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { TAB_KEYCODE } from '../../Utils/constant';
import { DatepickerContext } from '../context';
import styles from '@dtsl/css-datepicker/dist/index.module.css';
function DatepickerTrigger(props) {
  const {
    triggerLabel = '',
    triggerClassName = '',
    arrowClassName = '',
    onTriggerSelect = () => {},
    triggerStyles = {},
    triggerContainerStyles = {},
    disabled = false,
    dataTarget,
    disableFloatingUI
  } = props;
  const {
    isOpen,
    setIsOpen,
    withInput,
    datepickerTriggerRef,
    floatingUiProps,
    datepickerContainerRef
  } = useContext(DatepickerContext);
  const {
    refs
  } = floatingUiProps;
  const triggerClass = classNames({
    [styles['sib-datepicker-trigger']]: true,
    [styles['sib-datepicker-trigger-disabled']]: disabled,
    [styles['sib-datepicker-trigger-focused']]: isOpen && !withInput,
    [triggerClassName]: !!triggerClassName
  });
  const arrowClass = classNames({
    [styles['sib-dropdown-arrow']]: true,
    [arrowClassName]: !!arrowClassName
  });
  const handleOnClick = e => {
    e.preventDefault();
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
    onTriggerSelect(e);
  };
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleOnClick(event);
    }
    if (event.keyCode === 40) {
      handleOnClick(event);
    }
    if (event.keyCode === TAB_KEYCODE) {
      const targetPanelId = event.target?.getAttribute('data-target');
      datepickerContainerRef?.current?.parentElement?.id === targetPanelId && datepickerContainerRef?.current?.children[0]?.children[0]?.focus();
    }
  };
  const triggerUpdatedStyles = disableFloatingUI ? {
    ...triggerStyles,
    marginBottom: '8px'
  } : triggerStyles;
  const triggerButton = /*#__PURE__*/React.createElement("div", {
    className: triggerClass,
    style: triggerUpdatedStyles,
    ref: datepickerTriggerRef,
    role: "button",
    tabIndex: "0",
    onClick: !disabled ? handleOnClick : () => {},
    onKeyDown: !disabled ? handleKeyDown : () => {},
    "aria-haspopup": "listbox",
    "data-target": dataTarget
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-datepicker-trigger__placeholder']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-datepicker-trigger--selected-value'],
    dangerouslySetInnerHTML: {
      __html: triggerLabel || ''
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles[`sib-dropdown-arrow-wrapper`]
  }, /*#__PURE__*/React.createElement("span", {
    className: arrowClass
  })));
  return disableFloatingUI ? triggerButton : /*#__PURE__*/React.createElement("div", {
    ref: refs.setReference,
    style: triggerContainerStyles
  }, triggerButton);
}
DatepickerTrigger.propTypes = {
  triggerLabel: PropTypes.string.isRequired,
  triggerClassName: PropTypes.string,
  arrowClassName: PropTypes.string,
  onTriggerSelect: PropTypes.func,
  triggerStyles: PropTypes.object,
  triggerContainerStyles: PropTypes.object,
  disabled: PropTypes.bool,
  dataTarget: PropTypes.string,
  disableFloatingUI: PropTypes.bool
};
export default DatepickerTrigger;